/**
 * FastAPI base URL (no trailing slash).
 * In development, defaults to local API so login works without frontend/.env
 * (authStore previously used '' and posted to the CRA dev server by mistake).
 */
export function getBackendBaseUrl() {
  const raw = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');
  if (raw) return raw;
  if (process.env.NODE_ENV === 'development') {
    return 'http://127.0.0.1:8000';
  }
  return '';
}
